import { AppAlerts, AppDataTable, AppSectionTitle, AppTextLink } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useAlertsVisibility } from '@/shared-hooks/useAlertsVisibility'
import { createIncentiveColumns } from './-components/columns'
import { IncentiveConfirmDialog } from './-components/IncentiveConfirmDialog'
import { IncentiveFilterSection } from './-components/IncentiveFilterSection'
import { useIncentiveConfirmPage } from './-hooks/useIncentiveConfirmPage'

const ALERTS = [
  {
    type: 'info' as const,
    content: (
      <>
        <div>
          キャプテン制度やSales Stageの詳細に関しては
          <AppTextLink
            href='https://shiftinc365.sharepoint.com/:b:/s/msteams_32f884/IQB1XFhhHuMWSp55jDcvY92XAXRLVcfbMduKyITiQ14rbrY?e=ubvZq6'
            external
          >
            こちらの資料
          </AppTextLink>
          を参照ください。
        </div>
        <div className='mt-1'>
          不明点等のお問い合わせは
          <AppTextLink href='https://forms.cloud.microsoft/r/f4X2KELiHx' external>
            こちら
          </AppTextLink>
          からお願いします。
        </div>
      </>
    ),
  },
]

export const Route = createFileRoute('/_authenticated/opportunities/mypage/incentive-confirm/')({
  component: IncentiveConfirmPage,
  staticData: {
    breadcrumbLabel: 'インセンティブ',
  },
})

function IncentiveConfirmPage() {
  const [pageSize, setPageSize] = useState(20)
  const { visibleIndexes, onClose } = useAlertsVisibility(ALERTS.length)

  const {
    selectedPeriod,
    setSelectedPeriod,
    dialogOpen,
    setDialogOpen,
    filteredIncentives,
    availablePeriods,
    isLoading,
    error,
    isIncentiveAccepted,
    totalIncentiveAmount,
    isProcessing,
    copyToClipboard,
    handleOpenConfirmDialog,
    handleConfirmIncentive,
  } = useIncentiveConfirmPage()

  const columns = createIncentiveColumns(copyToClipboard)

  return (
    <div className='grid h-full grid-rows-[auto_minmax(0,1fr)]'>
      <AppSectionTitle
        collapsible
        content={
          <div className='p-8 space-y-6'>
            <AppAlerts alerts={ALERTS} visibleIndexes={visibleIndexes} onClose={onClose} />

            <IncentiveFilterSection
              selectedPeriod={selectedPeriod}
              onPeriodChange={setSelectedPeriod}
              availablePeriods={availablePeriods}
              isIncentiveAccepted={isIncentiveAccepted}
              onOpenConfirmDialog={handleOpenConfirmDialog}
            />
          </div>
        }
      >
        インセンティブ一覧
      </AppSectionTitle>

      <AppDataTable
        data={filteredIncentives}
        columns={columns}
        isLoading={isLoading}
        errorMessage={error ? `インセンティブの取得に失敗しました: ${error.message}` : undefined}
        pageSize={pageSize}
        onPageSizeChange={setPageSize}
        pageSizeOptions={[20, 40, 60]}
        emptyMessage='インセンティブデータがありません'
        defaultSortKey='period'
        defaultSortDirection='desc'
        getRowKey={(row) => row.id}
      />

      <IncentiveConfirmDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        period={selectedPeriod}
        totalAmount={totalIncentiveAmount}
        onConfirm={handleConfirmIncentive}
        isProcessing={isProcessing}
      />
    </div>
  )
}
